import React from "react";

import { Row, Col } from 'antd';

import LogoButton from "./LogoButton";
import OpenAppButton from "./OpenAppButton";

export default function WebHeader(props) {
    const popUpState = props.popUpState;
    const setPopUpState = props.setPopUpState;

    return (
        <div className="web-header-outter-box">
            <div className="web-header">
                <Row type="flex" justify="space-between" align="middle" gutter={[8, 8]}>
                    <Col>
                        <LogoButton />
                    </Col>
                    <Col>
                        <OpenAppButton popUpState={popUpState} setPopUpState={setPopUpState} />
                    </Col>
                </Row>
            </div>
        </div>

    );
}